import { Controller } from 'stimulus';

export default class ReviewCompanySortController extends Controller {
  sortType(event) {
    const select = event.target;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_type', select.value);
    window.location.href = url.toString();
  }
}
